import LiveVideoDetailLayout, { LiveVideoDetailLayoutProps } from '@/features/livestream/detail/layout';

export type { LiveVideoDetailLayoutProps };

export default LiveVideoDetailLayout;
